'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (target.className !== 'fa fa-remove red') {
      return;
    }
    $(".tooltip").remove();
  }, {
    capture: true
  });
};

var $ = require("jquery");

;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/removeTooltipManual.js
// module id = 450
// module chunks = 0